import React, { useEffect, useState } from "react";
import { API_URL } from "..";

const ColorModal = ({ show, onClose, data, onSaved }) => {
  const [title, setTitle] = useState("");
  const isEdit = data && data.id;

  useEffect(() => {
    if (isEdit) setTitle(data.title);
    else setTitle("");
  }, [data, isEdit]);

  if (!show) return null;

  const handleSubmit = async () => {
    if (!title.trim()) {
      alert("Title is required");
      return;
    }

    const method = isEdit ? "PUT" : "POST";
    const url = isEdit
      ? `${API_URL}/api/color/${data.id}`
      : `${API_URL}/api/color`;

    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ title }),
    });

    if (res.ok) {
      onSaved();
      onClose();
    } else {
      alert("Failed to save color");
    }
  };

  return (
    <div className="modal show" style={{ display: "block", background: "#00000080" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{isEdit ? "Edit Color" : "Add New Color"}</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            <label className="form-label">Color Name</label>
            <input
              type="text"
              className="form-control"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="e.g., Red, Black, White"
            />
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
            <button className="btn btn-primary" onClick={handleSubmit}>
              {isEdit ? "Update" : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColorModal;
